import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import {
  FormControl,
  FormGroupDirective,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ThemePalette } from '@angular/material/core';
import { LicenseService } from '@services/anpr/license.service';
import { ClientSmartHub } from '@classes/client/client';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseType } from '@classes/anpr/licenseType';

export interface DialogData {
  license: LicenseANPR;
  addedUses: number;
}

@Component({
  selector: 'app-update-license',
  templateUrl: './update-license.component.html',
  styleUrls: ['./update-license.component.scss'],
})
export class UpdateLicenseComponent implements OnInit {
  faArrow = faArrowRight;
  UpdateLicenseForm: UntypedFormGroup;
  color: ThemePalette = 'primary';
  types: LicenseType[] = [];
  isLoading: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UpdateLicenseComponent>,
    public dialog: MatDialog,
    private licenseService: LicenseService,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    this.getAllTypes();
  }

  getAllTypes() {
    this.isLoading = true;
    this.licenseService.getAllTypes().subscribe((res) => {
      this.types = res;
      this.initForm();
    });
  }

  onSubmit(): void {
    const updatedLicense: LicenseANPR = {
      id: this.data.license.id,
      client: this.data.license.client,
      type: this.UpdateLicenseForm.value.type,
      startingDate: this.data.license.startingDate,
      expiryDate: this.UpdateLicenseForm.value.hasExpiryDate
        ? this.UpdateLicenseForm.value.expiryDate
        : null,
      status: this.data.license.status,
      usesRemaining:
        (this.data.license.usesRemaining != null
          ? this.data.license.usesRemaining
          : 0) + this.UpdateLicenseForm.value.addedUses,
      comment: this.UpdateLicenseForm.value.comment,
    };
    this.openSnackBar('License updated', 'OK');

    this.licenseService.updateLicense(updatedLicense).subscribe({
      next: () => this.dialog.closeAll(),
    });
  }

  initForm(): void {
    this.data.addedUses = 0;
    this.UpdateLicenseForm = this.formBuilder.group({
      addedUses: [this.data.addedUses, Validators.pattern('^[0-9]+$')],
      expiryDate: [this.data.license.expiryDate],
      hasExpiryDate: [this.data.license.expiryDate != null],
      comment: [this.data.license.comment],
      type: [this.data.license.type, Validators.required],
    });
    this.isLoading = false;

    let type = this.types.filter((t) => t.id === this.data.license.type.id)[0];
    this.UpdateLicenseForm.get('type').setValue(type);

  }

  endLicense(): void {
    this.licenseService.endLicense(this.data.license.id);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }
}
